import { render, staticRenderFns } from "./ApiResultsAcquisitionInformation.vue?vue&type=template&id=2f77e23a&"
import script from "./ApiResultsAcquisitionInformation.vue?vue&type=script&lang=ts&"
export * from "./ApiResultsAcquisitionInformation.vue?vue&type=script&lang=ts&"
import style0 from "./ApiResultsAcquisitionInformation.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports